import {AddressRestDto, DeliveryPickupLocationRestDto} from "@/api/pharma-order-settings/models";
import {StatusEnum} from "@/api/enums/status-enum";
import {AddressRestDtoModel} from "@/models/AddressRestDtoModel";

export class DeliveryPickupLocationRestDtoModel implements DeliveryPickupLocationRestDto {

    name: string;
    status_code: StatusEnum;
    address?: AddressRestDto|null;

    constructor(name: string, status_code: StatusEnum, address: AddressRestDto) {
        this.name = name;
        this.status_code = status_code;
        this.address = address;
    }

    public static createWithDefaults(): DeliveryPickupLocationRestDtoModel {
        return new DeliveryPickupLocationRestDtoModel(
            '',
            StatusEnum.NOT_PUBLISHED,
            AddressRestDtoModel.createWithDefaults()
        );
    }
}
